<template>
<div>
  <el-upload
    action="#"
    ref="upload"
    :multiple="false"
    :auto-upload="false"
    :limit="1"
    :on-exceed="handleExceed"
    :file-list="data || []"
    >
    <el-button class="but" style="border-radius: 6px">
      <img src="../../assets/imgs/icon_upload@2x.png" style="width: 17px;margin-right: 2px;margin-bottom: -3px">点击上传
    </el-button>
  </el-upload>
</div>
</template>

<script>
export default {
  name:'Fileupload',
  props:{
    data: {
      type: Array,
      default: () => []
    },
  },
  data(){
    return{
      textList:[]
    }
  },
  methods:{
    getFiles(){
      return this.$refs['upload'].uploadFiles
    },
    handleExceed(files){
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件`);
    }
  }
}
</script>

<style scoped lang="less">
::v-deep .el-upload-list{
  text-align: initial;
}
.but{
  background-color: white;
  line-height: 32px;
  border: gainsboro 1px solid;
  color: #232323;
  cursor: pointer;
}
::v-deep .el-button{
  padding: 0 10px !important;
}
</style>
